import { useState, useEffect } from 'react';
import './HairDisclaimerModal.css';

const DEFAULT_POINTS = [
  'Photos of your hair and scalp are used only for this analysis session.',
  'Results are informational and not a medical diagnosis.',
  'Lighting and camera quality can affect accuracy — follow on-screen guidance.',
  'You can stop at any time and return to the salon hub.',
];

/**
 * Disclaimer before hair capture. Confirm to continue; Cancel closes.
 */
export default function HairDisclaimerModal({
  isOpen,
  onConfirm,
  onCancel,
  confirming = false,
}) {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (isOpen) setAccepted(false);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="hair-disclaimer-overlay"
      role="presentation"
      onClick={() => {
        if (!confirming) onCancel?.();
      }}
    >
      <div
        className="hair-disclaimer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hair-disclaimer-title"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="hair-disclaimer-eyebrow">Before you continue</p>
        <h2 id="hair-disclaimer-title" className="hair-disclaimer-title">
          Hair capture disclaimer
        </h2>
        <p className="hair-disclaimer-lede">
          We will guide you to photograph your crown and side hair areas so our AI can
          assess hair and scalp health.
        </p>
        <ul className="hair-disclaimer-list">
          {DEFAULT_POINTS.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <label className="hair-disclaimer-check">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            disabled={confirming}
          />
          <span>I understand and agree to continue with hair image capture.</span>
        </label>
        <div className="hair-disclaimer-actions">
          <button
            type="button"
            className="hair-disclaimer-btn hair-disclaimer-btn--secondary"
            onClick={onCancel}
            disabled={confirming}
          >
            Cancel
          </button>
          <button
            type="button"
            className="hair-disclaimer-btn hair-disclaimer-btn--primary"
            onClick={onConfirm}
            disabled={!accepted || confirming}
          >
            {confirming ? 'Starting…' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
